import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import EventAddParent from '../components/event/EventAddParent';
import {GREEN_BG, GREEN_BORDER} from '../backend/Colors';
import '../css/style.css';
import '../components/Home.css';

class EventAddLayout extends Component {

    render(){
        return (
            <SimpleLayout bg={GREEN_BG} bgStrong={GREEN_BORDER}>
                <EventAddParent />
            </SimpleLayout>              
        );
    }

}

export default EventAddLayout;